import { render, staticRenderFns } from "./MyStudentDetails.vue?vue&type=template&id=0bf16c72&scoped=true&"
import script from "./MyStudentDetails.vue?vue&type=script&lang=js&"
export * from "./MyStudentDetails.vue?vue&type=script&lang=js&"
import style0 from "./MyStudentDetails.vue?vue&type=style&index=0&id=0bf16c72&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf16c72",
  null
  
)

export default component.exports